// src/store/slices/session/sessionSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isModalVisible: false,
};

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    showSessionModal: (state) => {
      state.isModalVisible = true;
    },
    hideSessionModal: (state) => {
      state.isModalVisible = false;
    },
  },
});

export const { showSessionModal, hideSessionModal } = sessionSlice.actions;

export default sessionSlice.reducer;
